module.exports = __webpack_public_path__ + "img/SE.05461411.svg";